/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step4_DescriptionInputs */



/**
* | output |
* | --- |
* | "Optionally assign team access or add individual members" |
*
* @param {Spaces_Wizard_Step4_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step4_description = /** @type {((inputs?: Spaces_Wizard_Step4_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step4_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional Team-Zugriff zuweisen oder einzelne Mitglieder hinzufügen")
	return /** @type {LocalizedString} */ ("Optionally assign team access or add individual members")
});